import { render, staticRenderFns } from "./prohibitions.vue?vue&type=template&id=42926358&"
import script from "./prohibitions.vue?vue&type=script&lang=js&"
export * from "./prohibitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports